import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Article() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`${API}/posts/${slug}`)
      .then((r) => {
        if (!r.ok) throw new Error("not found");
        return r.json();
      })
      .then(setPost)
      .catch(() => setMissing(true));
  }, [slug]);

  return (
    <>
      <Navbar />
      <main data-testid="article-page" className="mx-auto max-w-3xl px-6 pb-32 pt-32 md:pt-40">
        <Link
          to="/journal"
          data-testid="article-back-link"
          className="inline-flex items-center gap-2 text-sm font-semibold text-plum"
        >
          <ArrowLeft size={15} /> All articles
        </Link>

        {missing && (
          <p data-testid="article-not-found" className="mt-16 font-serif text-2xl italic text-slate2">
            This page seems to have been borrowed. It isn't on the shelf right now.
          </p>
        )}

        {!post && !missing && (
          <p data-testid="article-loading" className="mt-16 font-serif text-xl italic text-slate2">
            Turning the pages…
          </p>
        )}

        {post && (
          <Reveal>
            <div className="mt-10 flex items-center gap-4 text-xs uppercase tracking-[0.2em]">
              <span data-testid="article-tag" className="font-semibold text-terracotta">{post.tag}</span>
              <span data-testid="article-date" className="text-slate2">
                {new Date(post.published_at).toLocaleDateString("en-IN", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </span>
            </div>
            <h1
              data-testid="article-title"
              className="mt-6 font-serif text-4xl leading-tight tracking-tight text-ink sm:text-5xl"
            >
              {post.title}
            </h1>
            {post.cover_image && (
              <div className="mt-10 overflow-hidden rounded-3xl">
                <img src={post.cover_image} alt={post.title} data-testid="article-cover" className="w-full object-cover" />
              </div>
            )}
            <div data-testid="article-body" className="mt-12 space-y-7">
              {post.body.split(/\n\s*\n/).map((para, i) => (
                <p
                  key={i}
                  className={`leading-relaxed text-slate2 ${
                    i === 0 ? "font-serif text-xl text-ink md:text-2xl" : "text-base md:text-lg"
                  }`}
                >
                  {para}
                </p>
              ))}
            </div>
            <div className="mt-16 border-t border-ink/10 pt-8">
              <p className="font-serif text-lg italic text-ink/70">
                Written from the reading room at Purple Space Library, Udupi.
              </p>
            </div>
          </Reveal>
        )}
      </main>
      <Footer />
    </>
  );
}
